
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        actionSequence: {
            type: Number,
            default: null
        }
    }
})
